import { Injectable, Output, EventEmitter } from '@angular/core';
import { AuthService } from './auth-service';
import { User } from '../../../models';
import * as _ from "lodash";
import * as moment from "moment/moment";
import { API } from './api.service';
import { ES } from './es.service';
import { Globals } from '../../../app/app.globals';
import { Http } from '@angular/http';

@Injectable()
export class UserService {
    @Output() userEventEmitter: EventEmitter<any> = new EventEmitter();

    constructor(private authService: AuthService, private api: API, private es: ES, private http: Http) {
    }

    getReferralCode() {
        return this.api.get('api/referral/');
    }
    getUserBasicInfo() {
        return this.api.get('api/dashboard/');
    }

    updateSearchable(is_searchable: boolean) {
        return this.api.post('user/update-searchable', {
            is_searchable: is_searchable
        });
    }

    changeScreenName(newName: string) {
        return this.api.post('user/update-screenname', {
            screenname: newName
        }).map(result => {
            localStorage.setItem('username', newName);
            this.getUserEventEmitter().emit({ name: 'screenname:changed', data: newName });
        });
    }

    getEthnicity() {
        return this.api.get('api/get-choices?choice_id=' + 2);
    }

    getNotification() {
        return this.api.get('api/notification-list');
    }
    getUserNotification() {
        return this.api.get('api/user-notification');
    }

    saveDemographic(userObj: User) {
        let tmpUserObj = _.pick(userObj, 'optional_race_id', 'gender', 'birthdate');
        tmpUserObj['birthdate'] = moment(userObj.birthdate).format('YYYY-MM-DD HH:mm:ss');
        return this.api.post('api/fan-profile', tmpUserObj);
    }

    saveNotification(userObj: User) {
        let tmpUserObj = _.pick(userObj, 'notification_type', 'notifications_frequency', 'notifications');
        return this.api.post('api/save-notification', tmpUserObj);
    }

    getEducation() {
        return this.api.get('api/get-choices?choice_id=' + 3);
    }

    getIncome() {
        return this.api.get('api/get-choices?choice_id=' + 1);
    }

    saveLifestyle(userObj: User) {
        let tmpUserObj = _.pick(userObj, 'optional_education_id', 'optional_income_id', 'marital_status', 'has_children');
        return this.api.post('api/lifestyle-profile', tmpUserObj);
    }

    saveBilling(userObj: User) {
        let tmpUserObj = _.pick(userObj, 'firstname', 'lastname', 'fullname', 'address1', 'town_city', 'state_region', 'postalcode', 'country');
        return this.api.post('api/address-profile', tmpUserObj);
    }

    getUserProfileData(type?: string) {
        if (!type) {
            type = 'profile';
        }
        return this.api.post('api/profile-data', { 'type': type });
    }

    uploadAvatar(binary: string) {
        return this.api.post('api/upload-avatar', { 'id': 1, 'image': binary })
            .map(result => {
                this.getUserEventEmitter().emit({ name: 'avatar:refresh' });
            });
    }

    getDiscoveriesRelations(page, searchTerm: any = false, sortOrder: any = false, limit: number = 20) {
        let queryString = '?offset=' + page + '&limit=' + limit;
        if (searchTerm !== false) {
            queryString += '&q=' + searchTerm;
        }
        if (sortOrder && sortOrder.key) {
            queryString += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
        }
        return this.api.get('user/user-discoveries' + queryString);
    }

    toggleFollowArtist(artistId: string) {
        return this.api.post('artists/follow', { 'object': artistId });
    }

    toggleFollowAccount(accountId: string) {
        return this.api.post('user/follow', { 'object': accountId });
    }

    loadDashboardActivities(page: any, userId = false) {
        let offset = (page.page - 1) * page.size;
        let url = 'user/activities?offset=' + offset;
        if (userId === false) {
            userId = null;
        } else {
            url += '&userId=' + userId;
        }
        return this.api.get(url);
    }

    loadUsersFollowing(page: any, userId: any = false) {
        let offset = (page.page - 1) * page.size;
        let url = 'user/followings?offset=' + offset;
        if (userId === false) {
            userId = null;
        } else {
            url += '&userId=' + userId;
        }
        return this.api.get(url);
    }

    loadUsersLikes(page: any, userId: any = false) {
        let offset = (page.page - 1) * page.size;
        let url = 'user/likes?offset=' + offset;
        if (userId === false) {
            userId = null;
        } else {
            url += '&userId=' + userId;
        }
        return this.api.get(url);
    }

    loadUserFollowers(page: any, userId: any = false) {
        let offset = (page.page - 1) * page.size;
        let url = 'user/followers?offset=' + offset;
        if (userId === false) {
            userId = null;
        } else {
            url += '&userId=' + userId;
        }
        return this.api.get(url);
    }

    public loadUserPlaylist(page: any, userId: any = false) {
        let offset = (page.page - 1) * page.size;
        let url = 'user/playlists?offset=' + offset;
        if (userId === false) {
            userId = null;
        } else {
            url += '&userId=' + userId;
        }
        return this.api.get(url);
    }

    getUserDetailsBySlug(slug: string) {
        return this.api.get('user/by-slug/' + slug);
    }

    getArchivedUserName(screenName: string) {
        return this.api.get('api/check-archived-screenname?screenname=' + screenName);
    }

    getSearchedAccounts(queryString: string, pageParams: any) {
        let options = this.es.setCriteria({}, 'account', pageParams, queryString);
        return this.es.listing(options).then((body) => {
            let hits = body.hits.hits;
            return _.keys(_.groupBy(hits, '_id'));
        });
    }

    public getAccountByIds(accountIds) {
        let queryParams = '';
        accountIds.forEach(function (arrayItem) {
            queryParams += 'id[]=' + arrayItem + '&';
        });
        return this.api.get('user?' + queryParams).map((res) => res);
    }

    public getUserAvatar() {
        if (this.authService.isUserLoggedIn()) {
            return new Globals().apiEndpoint + 'api/user-avatar?id=' + localStorage.getItem('username') + '&rnd=' + Math.random();
        }
    }

    public getUserLikes(domain: any, objectId: any) {
        let options = this.es.getLikeByTypeCriteria(domain, objectId);
        return this.es.listing(options).then((body) => {
            let hits = body.hits.hits;
            return _.keys(_.groupBy(hits, '_id'));
        });
    }

    public getAccountFollowers(objectId: any) {
        let options = this.es.getUserFollowersCriteria(objectId);
        return this.es.listing(options).then((body) => {
            let hits = body.hits.hits;
            return _.keys(_.groupBy(hits, '_id'));
        });
    }

    public checkScreenNameAvailibility(screenName: string) {
        return this.api.post('api/checkscreenname', { id: 0, screenname: screenName });
    }
    public checkValidReferral(referral_code: string) {
        return this.api.post('api/check-referral', { referral_code: referral_code });
    }

    public getUserEventEmitter() {
        return this.userEventEmitter;
    }

    public userSongsPlayedCount() {
        return this.api.post('api/get-user-songs-played', {});
    }

    public visitor() {
        return this.api.get('api/visitor');
    }

    public updateUserBio(bio: string) {
        return this.api.post('user/update-bio', { bio: bio });
    }

    public submitPaymentInfo(paymentInfo) {
        return this.api.post('packages/subscribe', paymentInfo);
    }
    public updatePaymentInfo(paymentInfo) {
        return this.api.post('packages/updatesubscribe', paymentInfo);
    }


    public submitOrderInfo(paymentInfo) {
        return this.api.post('cart/confirm', paymentInfo);
    }

    public cancelSubscription(subscriptionId) {
        return this.api.post('packages/unsubscribe', { id: subscriptionId });
    }

    public getPackages() {
        return this.api.get('packages');
    }

    public getCountries() {
        return this.http.get('https://d2zmbkdpl0cf9q.cloudfront.net/assets/countries.json').map((res) => res.json());
    }
    public getStates() {
        return this.http.get('https://d2zmbkdpl0cf9q.cloudfront.net/assets/UsStates.json').map((res) => res.json());
    }
    public getProvinces() {
        return this.http.get('https://d2zmbkdpl0cf9q.cloudfront.net/assets/canadaProvinces.json').map((res) => res.json());
    }
    public getCities() {
        return this.http.get('https://d2zmbkdpl0cf9q.cloudfront.net/assets/UsCities.json').map((res) => res.json());
    }
    public getCanadaCities() {
        return this.http.get('https://d2zmbkdpl0cf9q.cloudfront.net/assets/canadaPostalCodes.json').map((res) => res.json());
    }
    public getMyActivePackages(pageParams) {
        return this.api.get('packages/my-active-packages?page=' + pageParams.page);
    }

    public getActivePackageDetail(id: string) {
        return this.api.get('packages/my-package-detail?id=' + id);
    }

    public getMyPackagesHistory(pageParams) {
        return this.api.get('packages/my-packages?page=' + pageParams.page);
    }

    public getMyDownloads(page) {
        return this.api.get('downloads/my-downloads?page=' + page);
    }

    public getMyQuotaDetails() {
        return this.api.get('packages/my-quota-details');
    }

    public getPackageConsentDetails(packageId) {
        return this.api.get('packages/package-consent?packageId=' + packageId);
    }

    // to get the all time songs count
    public getSongsPlayedCountReal() {
        return this.api.post('api/get-user-songs-played-real', {});
    }

    // to get the current month songs count
    public getCurrentMonthSongsCount() {
        return this.api.post('api/get-user-songs-played-current-month', {});
    }

    // to get the current month songs count
    public getCurrentMonthPaidCount() {
        var userID = localStorage.getItem("user_id");
        return this.api.post('api/get-user-payed-current-month', { user_id: userID });
    }

}



// WEBPACK FOOTER //
// ./src/app/api/services/user-service.ts